/**
 * @fileoverview POST handler for the "/apps/connected_content_credential/edit" endpoint
 */
import fetch from "@lib/fetch";

import {
  createMutationFetcherFunctionWithShadowError,
  reactQueryMutationAdapter,
} from "../reactQueryFetcherAdapters";
import { appsConnectedContentCredentialEditCacheKeys } from "./constants";
import type {
  PostAppsConnectedContentCredentialEditProps,
  AppsConnectedContentCredentialEditResult,
  AppsConnectedContentCredentialEditResultErrors,
} from "./types";

export const postAppsConnectedContentCredentialEdit = reactQueryMutationAdapter(
  appsConnectedContentCredentialEditCacheKeys,
  createMutationFetcherFunctionWithShadowError<AppsConnectedContentCredentialEditResultErrors>()(
    (params: PostAppsConnectedContentCredentialEditProps): Promise<AppsConnectedContentCredentialEditResult> => {
      return fetch("/apps/connected_content_credential/edit", "POST", params);
    }
  )
);
